<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" style="background-image: url(assets/images/commercial-bg.jpg);">
        <div class="container">
            <div class="commercial-top-tab-list">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-tab-list-detail">
                        <ul>
                            <li><a routerLink="/history" >History of LCCC</a></li>
                            <li><a routerLink="/museum" >Museum</a></li>
                            <li><a routerLink="/honours" class="active">Honours</a></li>
                            <li><a routerLink="/records">Records</a></li>
                            <li><a routerLink="/ground">Ground Devlopments</a></li>                                 
                        </ul>
                    </div>
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">
        </div>
    </div>
    <div class="honours-hero-section cf">
        <div class="container">
            <div class="honours-hero-detail">
                <div class="titel-box">
                    <h2 class="titel-name">Honours</h2>
                </div>
                <div class="honours-hero-first-detail">
                    <div class="honours-hero-first-box" *ngFor="let honour of honoursList?.data">
                        <h2>{{honour?.title}}</h2>
                        <div class="honours-hero-first-box-detail">
                            <div class="honours-hero-box" *ngFor="let detail of honour?.history_honours_detail">
                                <div class="honours-hero-titel">
                                    <h3>{{detail?.title}}</h3>
                                </div>
                                <div class="honours-hero-content">
                                    <p *ngIf="detail?.winners">WINNERS:<span>{{detail?.winners}}</span></p>
                                    <p *ngIf="detail?.runners_up">RUNNERS-UP:<span>{{detail?.runners_up}}</span></p>
                                </div>
                            </div>
                            <!-- <div class="honours-hero-box">
                                <div class="honours-hero-titel">
                                    <h3>Sunday League/NatWestPro40</h3>
                                </div>
                                <div class="honours-hero-content">
                                    <p>WINNERS:<span>1974, 1977</span></p>
                                    <p>RUNNERS-UP:<span>1972, 2001</span></p>
                                </div>
                            </div>
                            <div class="honours-hero-box">
                                <div class="honours-hero-titel">
                                    <h3>Gillette Cup/NatWest/C&G Trophy</h3>
                                </div>
                                <div class="honours-hero-content">
                                    <p>RUNNERS-UP:<span>1992, 2001</span></p>
                                </div>
                            </div>
                            <div class="honours-hero-box">
                                <div class="honours-hero-titel">
                                    <h3>Benson and Hedges Cup</h3>
                                </div>
                                <div class="honours-hero-content">
                                    <p>WINNERS:<span>1972, 1975, 1985</span></p>
                                    <p>RUNNERS-UP:<span>1974, 1998</span></p>
                                </div>
                            </div>
                            <div class="honours-hero-box">
                                <div class="honours-hero-titel">
                                    <h3>Twenty20 Cup</h3>
                                </div>
                                <div class="honours-hero-content">
                                    <p>WINNERS:<span>2004, 2006, 2011</span></p>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <!-- <div class="honours-hero-second-box">
                        <h2>Second XI</h2>
                        <div class="honours-hero-second-box-detail">
                            <div class="honours-hero-box">
                                <div class="honours-hero-titel">
                                    <h3>Minor Counties Championship</h3>
                                </div>
                                <div class="honours-hero-content">
                                    <p>WINNERS:<span>1951</span></p>
                                </div>
                            </div>
                            <div class="honours-hero-box">
                                <div class="honours-hero-titel">
                                    <h3>Second XI Championship</h3>
                                </div>
                                <div class="honours-hero-content">
                                    <p>WINNERS:<span>1983, 2014</span></p>
                                    <p>RUNNERS-UP:<span>1961, 1975</span></p>
                                </div>
                            </div>
                            <div class="honours-hero-box">
                                <div class="honours-hero-titel">
                                    <h3>Second XI Trophy</h3>
                                </div>
                                <div class="honours-hero-content">
                                    <p>WINNERS:<span>1993, 1995, 1996, 2000, 2014</span></p>
                                </div>
                            </div>
                            <div class="honours-hero-box">
                                <div class="honours-hero-titel">
                                    <h3>Under-25 Competition</h3>
                                </div>
                                <div class="honours-hero-content">
                                    <p>WINNERS:<span>1975, 1983</span></p>
                                </div>
                            </div>
                            <div class="honours-hero-box">
                                <div class="honours-hero-titel">
                                    <h3>Second XI T20</h3>
                                </div>
                                <div class="honours-hero-content">
                                    <p>WINNERS:<span>2014</span></p>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</section><!-- page ends-->